import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLogout = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M16.461 17.37v2.77a1.385 1.385 0 0 1-1.384 1.384H5.385A1.385 1.385 0 0 1 4 20.14V4.91a1.385 1.385 0 0 1 1.385-1.385h9.692a1.385 1.385 0 0 1 1.384 1.384v2.77"
      />
      <path
        fill="currentColor"
        d="M19.76 9.225a.75.75 0 1 0-1.06 1.06l1.49 1.49h-7.882a.75.75 0 1 0 0 1.5h7.881L18.7 14.762a.75.75 0 0 0 1.06 1.061l2.76-2.758a.75.75 0 0 0-.002-1.084z"
      />
    </svg>
  );
};
export default SvgLogout;
